module.exports = __webpack_public_path__ + "img/1413333566.c3b7abe9.jpg";